import { render, staticRenderFns } from "./LockOption.vue?vue&type=template&id=8031a416&scoped=true&"
import script from "./LockOption.vue?vue&type=script&lang=js&"
export * from "./LockOption.vue?vue&type=script&lang=js&"
import style0 from "./LockOption.vue?vue&type=style&index=0&id=8031a416&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8031a416",
  null
  
)

export default component.exports